
<template>
<div class="widthFull ">

  <div class="widthFull headerBack section">


    <div class="container dataContainer">
      <div class="row justify-content-center ">

        <div class="col-md-6 ">
        </div>
        <div class="col-md-6 pt-5 mt-5 text-md-right text-center">
          <img class="img-fluid widthFull" src="../../assets/images/headerTitle.png">

          <button class="btn btn-primary btnYellow btn-lg mr-md-4 mt-5" type="button" v-scroll-to="'#howplay'">SCOPRI DI PIÙ</button>

        </div>

      </div>

    </div>

  </div>

  <div class="widthFull howplayBack section" id="howplay">
    <div class="container ">

      <div class="row justify-content-center ">
        <div class="col-md-5 pt-5  center"></div>
        <div class="col-md-7 pt-5 mb-5 center ">
          <img class="img-fluid widthFull pt-5 howPlayTitle" src="../../assets/images/how_play_title.png">

          <div class="row justify-content-center align-items-center">
            <div class="col-md-6">
              <div class="howplayContainers center mt-5">
                <img class="img-fluid widthFull widthFull howPlayImg" src="../../assets/images/step1.png">

                <p class="pl-2 pr-2 pb-2 noVisible">
									Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has
									 been the industry's
                  </p>
              </div>
            </div>
						<div class="col-md-6">
							<div class="howplayContainers center mt-5">
								<img class="img-fluid widthFull widthFull howPlayImg" src="../../assets/images/step2.png">
								<p class="pl-2 pr-2 pb-2 noVisible">
									Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has
									 been the industry's
									</p>
							</div>
						</div>
						<div class="col-md-6">
							<div class="howplayContainers center mt-1">
								<img class="img-fluid widthFull widthFull howPlayImg" src="../../assets/images/step3.png">
								<p class="pl-2 pr-2 pb-2 noVisible">
									Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has
									 been the industry's
									</p>
							</div>
						</div>
						<div class="col-md-6">
							<div class="howplayContainers center mt-1">
								<img class="img-fluid widthFull widthFull howPlayImg" src="../../assets/images/step4.png">
								<p class="pl-2 pr-2 pb-2 noVisible">
									Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has
									 been the industry's
									</p>
							</div>
						</div>
						<div class="col-md-6">
							<div class="howplayContainers center mt-1">
								<img class="img-fluid widthFull widthFull howPlayImg" src="../../assets/images/step5.png">
								<p class="pl-2 pr-2 pb-2 noVisible">
									Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has
									 been the industry's
									</p>
							</div>
						</div>

						<div class="col-md-6 center">
							<!--<router-link v-if="!isAuthenticated" class="btn btn-primary btn-lg btnYellow mr-4 mt-2 " to="/registration">Registrati subito</router-link>-->
              <router-link v-if="hasPrev && isAuthenticated" class="btn btn-primary btn-lg btnYellow mr-4 mt-2 " to="/calcolatore">Calcolatore Preventivi</router-link>
              <router-link v-else-if="!hasPrev && isAuthenticated" class="btn btn-primary btn-lg btnYellow mr-4 mt-2 " to="/calcolatore">Crea pratica</router-link>
						</div>

          </div>

        </div>

      </div>

    </div>
  </div>


  <div class="widthFull servicesBack section" id="services">
    <!--<div class="container ">

      <div class="row justify-content-center ">

        <div class="col-md-5 pt-5 center"></div>
        <div class="col-12 col-md-7 pt-5 center">

          <img class="img-fluid widthFull pt-5 pr-md-5 pl-md-5 " src="../../assets/images/services_tittle.png">
          <img class="img-fluid widthFull pt-5 pr-md-5 pl-md-5 " src="../../assets/images/services.png">
          <router-link class="btn btn-primary btn-lg btnYellow mr-4 mt-4 " to="/calcolatore">calcoLatore preventivi</router-link>

        </div>

      </div>

    </div>
  -->

    <div class="container ">

      <div class="row justify-content-center ">
        <div class="col-md-4 pt-5  center"></div>
        <div class="col-md-8 pt-5 mb-5 center ">
          <img class="img-fluid widthFull pt-5 howPlayTitle" src="../../assets/images/services_tittle.png">

          <div class="row justify-content-center pt-5 pb-3">
            <div class="col-md-4">
              <div class=" center">
                <img class="img-fluid widthFull widthFull " src="../../assets/images/service1.png">
              </div>
            </div>
            <div class="col-md-8">
              <div class="text-left">
                <p class="pl-2 pr-2 black smallDesc">
                  <strong class="h4 black"><b>BONUS CASA</b></strong>
                  <br/>Lavori di ristrutturazione di abitazioni e parti comuni di edifici residenziali
                  Per saperne di più
                  <br/> <a class="yellow link green underline" target="_blank" href="https://www"> Per saperne di più</a>
                </p>
              </div>
            </div>
          </div>

          <div class="row justify-content-center pb-3">
            <div class="col-md-4">
              <div class=" center">
                <img class="img-fluid widthFull widthFull " src="../../assets/images/service2.png">
              </div>
            </div>
            <div class="col-md-8">
              <div class="text-left">
                <p class="pl-2 pr-2 black smallDesc">
                  <strong class="h4 black"><b>ECOBONUS</b></strong>
                  <br/>interventi di riqualificazione energetica degli edifici esistenti: sostituzione della vecchia caldaia con una caldaia a condensazione in classe A,
                  installazione di pannelli solari  o sostituzione di impianti di riscaldamento con pompe di calore ad alta efficienza ed impianti geotermici a bassa entalpia.
                  <br/> <a class="yellow green link underline" target="_blank" href="https://www"> Per saperne di più</a>
                </p>
              </div>
            </div>
          </div>

          <div class="row justify-content-center pb-3">
            <div class="col-md-4">
              <div class=" center">
                <img class="img-fluid widthFull widthFull " src="../../assets/images/service3.png">
              </div>
            </div>
            <div class="col-md-8">
              <div class="text-left">
                <p class="pl-2 pr-2 black  smallDesc">
                  <strong class="h4 black"><b>ECOBONUS</b></strong>
                  <br/>interventi di riqualificazione energetica degli edifici esistenti: sostituzione della vecchia caldaia con una caldaia a condensazione in classe A
                   abbinata a sistemi di termoregolazione evoluti (appartenenti alle classi V, VI o VIII), installazione di pannelli solari  o sostituzione di impianti di
                  riscaldamento con pompe di calore ad alta efficienza ed impianti geotermici a bassa entalpia .
                  <br/> <a class="yellow link green underline" target="_blank" href="https://www"> Per saperne di più</a>
                </p>
              </div>
            </div>
          </div>

          <div class="row justify-content-center pb-3">
            <div class="col-md-4">
              <div class=" center">
                <img class="img-fluid widthFull widthFull " src="../../assets/images/service4.png">
              </div>
            </div>
            <div class="col-md-8">
              <div class="text-left">
                <p class="pl-2 pr-2 black smallDesc">
                  <strong class="h4 black"><b>SUPERBONUS</b></strong>
                  <br/>Detrazione per le spese sostenute per specifici interventi di riqualificazione energetica dal 1° luglio 2020 al 31 dicembre 2021
                  <br/> <a class="yellow link green underline" target="_blank" href="https://www"> Per saperne di più</a>
                </p>
              </div>
            </div>
          </div>


          <div class="row justify-content-right ">
            <div class="col-md-6 center"></div>
            <div class="col-md-6 center">
              <!--<router-link v-if="!isAuthenticated" class="btn btn-primary btn-lg btnYellow mr-4 mt-2 " to="/registration">Registrati subito</router-link>-->
              <router-link v-if="hasPrev && isAuthenticated" class="btn btn-primary btn-lg btnYellow mr-4 mt-2 " to="/calcolatore">Calcolatore Preventivi</router-link>
              <router-link v-else-if="!hasPrev && isAuthenticated" class="btn btn-primary btn-lg btnYellow mr-4 mt-2 " to="/calcolatore">Crea pratica</router-link>
            </div>

          </div>

          </div>

        </div>

      </div>

    </div>

  </div>


</div>
</template>

<script>
import {
  mapGetters,
  mapState
} from 'vuex'
import {
  USER_REQUEST
} from 'actions/user'
import axios from 'axios'

const moment = require('moment')

export default {
  components: {

  },
  data() {
    return {
      moment: require('moment'),
      status: 'home',
      id: '',
      hasPrev:false

    }
  },
  name: 'home',
  methods: {


    showError(text) {
      this.$swal({
        type: 'error',
        title: text,
        html: '',
        confirmButtonText: 'CHIUDI',
        confirmButton: 'closeProductsModal',
        confirmButtonColor: '#b61617',

      });
    },

setProfile: function(){
  
//type 1 => no preventivatore
if(this.profile.type == 1){
  this.hasPrev = false
}
if(this.profile.status == 'admin'){
  this.adminIs = true
}else if(this.profile.status == 'user'){
  this.adminIs = false
}

}
  },
  watch: {

    getProfile: function() {
      this.setProfile()
    },

  },
  mounted: function() {
    this.setProfile()

  },
  beforeUpdate: function() {

  },
  computed: {
    ...mapGetters(['isAuthenticated', 'authStatus', 'getProfile']),
    ...mapState({
      authLoading: state => state.auth.status === 'loading',
      profile: state => state.user.profile,
      managedArea:state => state.user.profile.type
    }),
    loading: function() {
      return this.authStatus === 'loading' && !this.isAuthenticated
    }
  },
}
</script>

<style lang="css" scoped>

.btnOverlay{
	margin-top: -350px!important;
}

.headerBack{

background: url(../../assets/images/headerBack.jpg);
background-size: cover;
background-position: bottom;
background-repeat: no-repeat;

}

.section{
	min-height: calc(100vh - 0px);
}

.howplayBack{

background: url(../../assets/images/howplayBack.jpg);
background-size: cover;
background-position: top;
background-repeat: no-repeat;

}

.servicesBack{

background: url(../../assets/images/servicesBack.jpg);
background-size: cover;
background-position: bottom;
background-repeat: no-repeat;

}



.verySmall {
    font-size: 14px!important;
    padding: 8px!important;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    vertical-align: middle;
    margin: 10px;
}
.disabled {
    background: #4d4d4d!important;
}
.back{
	background: #ececec;
}

</style>



// WEBPACK FOOTER //
// src/components/home/index.vue